module.exports = __webpack_public_path__ + "img/storage-2.70d34dd0.png";